import React from 'react';
import i18next from 'i18next';

import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import en from './i18n/en';
import it from './i18n/it';

const PermissionsManagementPage = lazyRetry(() => import('./PermissionsManagementPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ authorizer }) => authorizer.can('view', 'permissions'),
	routes: [
		{
			path: 'permissions-management/:tabId?',
			element: <PermissionsManagementPage />
		}
	]
};

export default routes;
